module.exports = __webpack_public_path__ + "img/nav-arrow-w.ffc94e6b.svg";